import { join } from 'pathe';
import type { NuxtRuntimeConfig } from '@nuxt/bridge-schema';

export async function contentDataFor(
  path: string,
  config: NuxtRuntimeConfig | undefined = undefined
) {
  // On server-side, we can load the file directly.
  if (process.server) {
    try {
      const { securePath } = await import('~/server/lib/deliver-file');
      const { readFileSync } = await import('node:fs');

      const secureRealPath = securePath(
        join('public/content/content-json', path),
        'public/content/content-json',
        ['json']
      );

      const data = readFileSync(secureRealPath, 'utf8');
      return JSON.parse(data);
    } catch (error) {
      // @ts-ignore
      const message = `[Lib] contentdata file not found: "${path}" (${error.message})`;
      console.error(message);
      return {};
    }
  }

  const publicConfig = config?.public || config;
  if (!publicConfig) {
    console.error("You'll have to provide a config.");
    return {};
  }

  // on client side we have to request the file
  try {
    const response = await fetch(
      `${
        publicConfig.cloudFront?.contentEnabled ? config?.app?.cdnURL : ''
      }/content/content-json/${path}`
    ).then((r) => r.json());
    return response || {};
  } catch (error: Error | any) {
    const isProduction = config.public?.mode?.isProduction || config.mode?.isProduction;
    if (!isProduction) {
      console.error(error);
    }
    return {};
  }
}
